export const TaxNumber = {
  VAT: 'VAT',
  EIN: 'EIN',
  NONE: 'NONE',
};
